import { AttemptQuestionResult } from "../../../services/gameQuizAttempts/gameQuizAttempts.types";

/**
 * Veredicto legible de una pregunta. `color` sale de la paleta de Tag de antd
 * (mismo criterio que STATUS_META: presets semánticos, nunca hex crudo).
 *
 * Se distingue "Parcial" de "Incorrecta" porque el scorer da crédito
 * fraccionario: en un categorization de 4 elementos, colocar 3 bien no es lo
 * mismo que no colocar ninguno, y un profesor necesita ver esa diferencia para
 * saber si la clase entendió a medias o no entendió nada.
 */
export interface QuestionVerdict {
  color: string;
  label: string;
}

type VerdictInput = Pick<AttemptQuestionResult, "answered" | "correct" | "score">;

export const verdictOf = (result: VerdictInput): QuestionVerdict => {
  if (!result.answered) return { color: "default", label: "Sin responder" };
  if (result.correct) return { color: "green", label: "Correcta" };
  if (result.score > 0) {
    return {
      color: "orange",
      label: `Parcial · ${Math.round(result.score * 100)}%`,
    };
  }
  return { color: "red", label: "Incorrecta" };
};
